module.exports = __webpack_public_path__ + "img/graph-paper-notebook_B099FW1JV8.6ed13026.jpg";